export default [{
  name: 'sarfaty',
  namespaced: true,
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
  },
}]
